import {
  SET_ACTIVE_VENDOR,
  SET_VENDORS_LIST,
  SET_VENDOR_SEED,
  RESET_VENDOR_STATE,
} from "../types";

const initialState = {
  vendorsList: [],
  vendorsSeed: {},
  activeVendor: {},
};

const integrationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VENDORS_LIST:
      return {
        ...state,
        vendorsList: action.payload,
      };
    case SET_VENDOR_SEED:
      return {
        ...state,
        vendorsSeed: action.payload,
      };
    case SET_ACTIVE_VENDOR:
      return {
        ...state,
        activeVendor: action.payload,
      };
    case RESET_VENDOR_STATE:
      return initialState;
    default:
      return state;
  }
};

export default integrationReducer;
